import React from "react";
import WhatsAppImg from "../assets/whatsapp.png"; // your WhatsApp icon
import "../WhatsApp/WhatsApp.css"


const WhatsApp = () => {
  return (
    <div className="whatsapp-container">
      <a
        href="https://wa.me/918527472989?text=Hello How Can I help you ?"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-link"
      >
        {/* Blue bubble */}
        <span className="whatsapp-bubble">Hello! How can I help you?</span>

        {/* Green round icon wrapper */}
        <div className="whatsapp-icon">
          <img src={WhatsAppImg} alt="WhatsApp" />
        </div>
      </a>
    </div>
  );
};

export default WhatsApp;
